<template>
  <form-field :title="label" is-require is-link @click="onClick">
    <div v-if="!display" class="placeholder">请选择{{ label }}</div>
    <div v-else>{{ display }}</div>
    <van-popup v-model="isShow" class="job-category-popup" get-container="body" position="bottom" round safe-area-inset-bottom close-on-popstate @open="onOpen">
      <div class="nav-bar">
        <div class="nav-bar-left" @click="onBack">
          取消
        </div>
        <div class="nav-bar-title">选择{{ label }}</div>
        <div class="nav-bar-right" />
      </div>
      <div class="content">
        <div class="searchbar">
          <div class="searchbar__form">
            <van-search v-model.trim="keywords" shape="round" clearable :placeholder="`搜索${label}`" />
            <!-- <input v-model.trim="keywords" class="searchbar__input" type="text" :placeholder="`请输入${label}`">
            <div v-if="keywords" class="searchbar__clear" @click="onClear">
              <base-icon name="ic_clear" />
            </div> -->
          </div>
        </div>
        <div v-show="keywords && !results.length" class="searchbar__no-result">
          <span>{{ message }}</span>
        </div>
        <div v-show="keywords && results.length" class="searchbar__result">
          <div v-for="item in results" :key="item.subCate.id" class="result-item" @click="onClickResult(item)">
            <div class="title" v-html="item.title" />
            <div class="desc">{{ item.cate.name }} > {{ item.subCate.name }}</div>
          </div>
        </div>
        <div v-show="!keywords" class="tree-select">
          <div class="tree-select__nav">
            <div v-for="item in categoryData" :key="item.id" :class="['tree-select__item', { 'tree-select__item--select': item.id === currentNav.id }]" @click="onClickNav(item)">
              {{ item.name }}
            </div>
          </div>
          <div class="tree-select__content">
            <div v-for="item in subCategoryData" :key="item.id" :class="['tree-select__item', { 'tree-select__item--active': item.id === currentContent.id }]" @click="onClickContent(item)">
              <span class="tit">{{ item.name }}</span>
              <base-icon v-if="item.id === currentContent.id" name="right_arrow" class="icon"></base-icon>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </form-field>
</template>
<script>
import debounce from 'lodash/debounce';
export default {
  name: 'FormJobCategory',
  props: {
    value: Array,
    label: {
      type: String,
      default: '服务分类',
    },
    isProject: Boolean,
  },
  data() {
    return {
      isShow: false,
      keywords: '',
      message: '',
      currentNav: {},
      currentContent: {},
      categoryList: [],
      categoryData: [],
      results: [],
      display: '',
    };
  },
  computed: {
    subCategoryData() {
      const cate = this.categoryData.find(item => item.id === this.currentNav.id);
      return cate ? cate.infoCategory : [];
    },
  },
  watch: {
    keywords(val) {
      this.message = '搜索中...';
      this.getCate(val);
    },
    value: {
      handler(val) {
        this.getDisplay(val);
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    onClear() {
      this.keywords = '';
    },
    onBack() {
      this.isShow = false;
    },
    onClick() {
      this.isShow = true;
    },
    onOpen() {
      if (!this.value.length) {
        return;
      }
      this.keywords = '';
      this.results = [];
      const [cateId, subCateId] = this.value;
      this.currentNav = this.categoryData.find(item => item.id === cateId) || this.categoryData[0];
      this.currentContent = this.subCategoryData.find(item => item.id === subCateId) || this.currentNav.infoCategory[0];
    },
    onClickNav(item) {
      this.currentNav = item;
    },
    onClickContent(item) {
      this.currentContent = item;
      const currentValue = [item.subarea_id, item.id];
      // this.getDisplay(currentValue);
      this.$emit('input', currentValue);
      this.isShow = false;
    },
    onClickResult(item) {
      const currentValue = [item.cate.id, item.subCate.id];
      // this.getDisplay(currentValue);
      this.$emit('input', currentValue);
      this.isShow = false;
    },
    getDisplay(ids) {
      const current = this.categoryList.find(item => item.subCate.id === ids[1]);
      if (current && current.cate && current.cate.name && current.subCate && current.subCate.name) {
        this.display = current.cate.name + '-' + current.subCate.name;
        return;
      }
      this.display = '';
    },
    async fetchData() {
      try {
        const res = this.isProject ? await this.$api.getRecruitSubareaList() : await this.$api.getOddSubareaList();
        console.time();
        this.categoryData = res;
        this.currentNav = res[0];
        let categoryList = [];
        res.forEach(item => {
          item.infoCategory.forEach(cate => {
            categoryList.push({
              cate: { id: item.id, name: item.name },
              subCate: cate,
            });
          });
        });
        this.categoryList = categoryList;
        this.getDisplay(this.value);
      } catch (err) {
        this.$toast(err.message);
      }
    },
    getResult(list) {
      this.results = list.map(item => {
        // 匹配关键字正则
        const replaceReg = new RegExp(this.keywords, 'g');
        // 高亮替换v-html值
        const replaceString = `<mark class="text-highlight">${this.keywords}</mark>`;
        return {
          ...item,
          title: item.subCate.name.replace(replaceReg, replaceString),
        };
      });
    },
    getCate: debounce(async function (keywords) {
      if (!keywords || !keywords.length) {
        this.results = [];
        return;
      }
      // 匹配关键字正则
      const replaceReg = new RegExp(keywords);
      const arr = this.categoryList.filter(item => {
        const isResult = replaceReg.test(item.subCate.name)
        return isResult;
      });
      if (!arr.length) {
        this.message = `没有找到 ${keywords} 相关分类`;
      }
      this.getResult(arr);
    }, 500),
  },

};
</script>
<style lang="less" scoped>
.placeholder {
  font-size: 32px;
  color: #bbb;
}
.job-category-popup {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 80%;
  overflow: hidden;
  .nav-bar {
    position: relative;
    height: 100px;
    background-color: #fff;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    border-bottom: none !important;
    .nav-bar-left,
    .nav-bar-right {
      position: absolute;
      top: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      padding: 0 32px;
      font-size: 28px;
    }
    .nav-bar-left {
      left: 0;
      color: #999;
    }
    .nav-bar-right {
      right: 0;
    }
    .nav-bar-title {
      max-width: 60%;
      margin: 0 auto;
      color: #333;
      font-weight: 500;
      font-size: 36px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    .searchbar {
      flex-shrink: 0;
      .searchbar__form {
        margin-top: 10px;
        padding: 0 30px;
        height: 100px;
        display: flex;
        flex-direction: column;
        border-bottom: 1px solid #edeef2;
        .searchbar__input {
          flex: 1;
          border: 0;
          font-size: 32px;
        }
        .searchbar__clear {
          width: 36px;
          height: 36px;
          margin-left: 20px;
          flex-shrink: 0;
        }
      }
    }
    .searchbar__no-result {
      color: #212736;
      font-size: 30px;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .searchbar__result {
      flex: 1;
      overflow: auto;
      padding: 0 40px;
      .result-item {
        padding: 40px 0;
        & + .result-item {
          border-top: 1px solid #edeef2;
        }
        .title {
          font-size: 30px;
          color: #333;
          margin-bottom: 20px;
        }
        .desc {
          font-size: 28px;
          color: #999;
        }
      }
    }
    .tree-select {
      flex: 1;
      display: flex;
      overflow: hidden;
      &__item {
        font-size: 32px;
        display: flex;
        padding: 40px;
        .tit {
          line-height: 1;
          color: #333;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          flex: 1;
        }
        .icon {
          height: 36px;
          width: 36px;
        }
        &--select {
          background-color: #fff;
          color: #e84c3d;
        }
        &--active {
          color: #e84c3d;
          .tit {
            color: #e84c3d;
          }
        }
      }
      &__nav {
        flex: 1;
        overflow-y: auto;
        background-color: #f7f7f7;
      }
      &__content {
        flex: 1;
        overflow-y: auto;
        background-color: #fff;
      }
    }
  }
}
/deep/ .van-search {
  padding: 0;
  width: 100%;
  .van-cell {
    padding: 12px 8px 12px 0;
  }
}
</style>